import { useContext } from "react";
import { DrawerContext } from "./DrawerContext";

/**
 * Hook to access the drawer context.
 *
 * @returns The drawer context containing close function and ref
 * @throws Error if used outside of a DrawerContextProvider
 */
export function useDrawerContext() {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error(
      "useDrawerContext must be used within a DrawerContextProvider",
    );
  }
  return context;
}
